// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"l5-z","dimensionLabel":"m5-z","styleChooserControlWrapper":"n5-z","styleChooserControl":"o5-z","disabled":"p5-z","giftCard":"q5-z","styleChooserText":"r5-z"};